import { errorToast } from "@/ui/toast/Toast";
import i18n from "@/i18n";
import { createSubscriptionOrder } from "../api";
import { useApiSend } from "@/hooks/useApi";
import { PLAN_PRICES, CURRENCY } from "../plans";

// Order number (broj narudžbe). Prefer a real id from the backend response if
// it ever returns one; otherwise generate a unique client-side reference.
function resolveOrderId(data) {
	const fromApi =
		data?.order_id ?? data?.order_number ?? data?.order ?? data?.id ?? null;
	if (fromApi != null) return String(fromApi);
	if (typeof crypto !== "undefined" && crypto.randomUUID)
		return crypto.randomUUID();
	return `ord_${Date.now()}_${Math.floor(Math.random() * 1e6)}`;
}

export function useSubscribe() {
	const { mutateAsync, isPending, isError, error } = useApiSend({
		fn: createSubscriptionOrder,
	});

	const subscribe = async function (payment_plan) {
		const data = await mutateAsync(payment_plan);

		if (data?.checkout_url) {
			// Stash what's being bought so /thank-you can report it to the
			// Pixel after the external checkout redirects back.
			localStorage.setItem(
				"pendingPurchase",
				JSON.stringify({
					// Prefer the real values returned by the backend; fall
					// back to the local plan map for older API responses.
					plan: data.payment_plan ?? payment_plan,
					value: data.total ?? PLAN_PRICES[payment_plan],
					currency: data.currency ?? CURRENCY,
					orderId: resolveOrderId(data),
				})
			);
			window.location.href = data.checkout_url;
		} else
			errorToast(i18n.t("payments:toast.subscribeLinkFailed"));
	};

	return { subscribe, isPending, error, isError };
}
